import { render, staticRenderFns } from "./AlacakForm.vue?vue&type=template&id=566750b6&scoped=true"
import script from "./AlacakForm.vue?vue&type=script&lang=ts"
export * from "./AlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566750b6",
  null
  
)

export default component.exports